import { bootstrapApplication } from '@angular/platform-browser';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Single MSAL instance shared between the app and the redirect handler.
// (Bootstrapping MsalRedirectComponent as a second root app created a second
// PublicClientApplication, which caused "interaction_in_progress" errors.)
bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => appRef.bootstrap(MsalRedirectComponent))
  .catch(err => console.error(err));
